import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { sxConfig } from './workspace.style';
import { AutoCompleteSelectUI, FormLabelUI } from '../../Interface';

const InfoSidebar = ({ autoCompleteOptions, selectedValues }) => {
  return (
    <Stack spacing={2}>
      <Accordion
        defaultExpanded
        sx={{
          ...sxConfig.card,
          '&.Mui-expanded': {
            margin: 0,
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={700}>Adatlap</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AutoCompleteSelectUI
            label={<FormLabelUI text="Felelős" />}
            variant="outlined"
            size="small"
            dataset={autoCompleteOptions.user}
            disableClearable
            selectedValue={selectedValues.responsiblePersonId}
            selectedLabelValue={selectedValues?.responsiblePerson?.nickName}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded sx={sxConfig.card}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={700}>Általános információk</Typography>
        </AccordionSummary>
        <AccordionDetails></AccordionDetails>
      </Accordion>
    </Stack>
  );
};

export default InfoSidebar;
